import Component from '../../common/Component';
import ItemList from '../../common/utils/ItemList';
import app from '../app';
/**
 * The `HeaderPrimary` component displays primary header controls. On the
 * default skin, these are shown just to the right of the forum title.
 */
export default class BottomSlideShow extends Component {

  static initAttrs(attrs) {
    attrs.className = attrs.className || '';
    attrs.slideName = attrs.slideName || '';
    attrs.sildeWidth = attrs.slideWidth || 0;
    attrs.containerId = attrs.containerId || 0;
    attrs.items = attrs.items || [];
  }

  oninit(vnode) {
    super.oninit(vnode);
    this.slideIndex = 1;
    this.slideLength = this.attrs.items.length;
    this.sliding = false;
    this.hover = false;
    this.items = this.attrs.items;
    this.auto = false;
    if (this.items) {
      this.noScroll = this.items.length < 4;
      this.canSlide = this.items.length > 0;
    } else {
      this.noScroll = false;
      this.canSlide = false;
    }
  }

  oncreate(vnode) {
    super.oncreate(vnode);

    window.addEventListener('mousemove', this.checkHover.bind(this));

    setTimeout(() => {
      if (this.canSlide) {
        this.setOriginalPosition();
        setTimeout(() => {
          if (!this.auto) {
            this.auto = true;
            this.setAuto();
          }
        }, 2000);

      }
    }, 100);
  }

  onremove(vnode) {
    if (this.canSlide) {
      window.removeEventListener('mouseover', this.checkHover.bind(this));
    }
    this.auto = false;
    super.onremove(vnode);
  }

  view(vnode) {
    const items = this.items;
    if (!items || items.length == 0) return null;
    return (
      <div class="bottomslide-container web">
        <div id={this.attrs.containerId} class='image-container'>
          {this.getImageList(items)}
        </div>
        <a class='prev' onclick={this.prevSlides.bind(this)}>❮</a>
        <a class='next' onclick={this.nextSlides.bind(this)}>❯</a>
      </div>
    );
  }

  getImageList(items) {
    if (items.length == 0 || !items) return null;

    const style = "width: " + (this.attrs.sildeWidth) + "px;"
    return items.map((item) => {
      return (<span className={'mySlides ' + this.attrs.slideName} >
        <img src={item.img} style={style} onclick={this.openUrl.bind(this, item.url)} />
        <div class="mySlide-text">广告</div>
      </span>);
    });
  }

  openUrl(url) {
    if (url != "")
      window.open(url);
  }

  prevSlides() {
    if (this.sliding || this.hover || !this.canSlide) return;
    this.sliding = true;

    this.slideIndex--;
    if (this.slideIndex < 1) this.slideIndex = this.slideLength;

    this.showSlides('prev');
  }

  nextSlides() {
    if (this.sliding || this.hover || !this.canSlide) return;
    this.sliding = true;

    this.showSlides('next');

    this.slideIndex++;
    if (this.slideIndex > this.slideLength) this.slideIndex = 1;
  }

  showSlides(direction) {
    let moveIndexes = this.getMoveIndexes();
    let slides = document.getElementsByClassName(this.attrs.slideName);

    document.querySelectorAll('.' + this.attrs.slideName).forEach(element => {
      element.classList.remove('transition');
    });

    if (direction == 'prev') {
      slides[moveIndexes[0] - 1].style.left = "-" + (this.attrs.sildeWidth + 10) + "px";


      setTimeout(() => {
        document.querySelectorAll('.' + this.attrs.slideName).forEach(element => {
          element.classList.add('transition');
        });
        slides[moveIndexes[0] - 1].style.left = (this.getPrevPosition(1)) + "px";
        slides[moveIndexes[1] - 1].style.left = (this.getPrevPosition(2)) + "px";
        slides[moveIndexes[2] - 1].style.left = (this.getPrevPosition(3)) + "px";
        slides[moveIndexes[3] - 1].style.left = (this.getPrevPosition(4)) + "px";
        slides[moveIndexes[4] - 1].style.left = (this.getPrevPosition(5)) + "px";
      }, 40);

    } else {
      slides[moveIndexes[4] - 1].style.left = (this.attrs.sildeWidth * 4 + 40) + "px";

      setTimeout(() => {
        document.querySelectorAll('.' + this.attrs.slideName).forEach(element => {
          element.classList.add('transition');
        });
        slides[moveIndexes[0] - 1].style.left = (this.getNextPosition(1)) + "px";
        slides[moveIndexes[1] - 1].style.left = (this.getNextPosition(2)) + "px";
        slides[moveIndexes[2] - 1].style.left = (this.getNextPosition(3)) + "px";
        slides[moveIndexes[3] - 1].style.left = (this.getNextPosition(4)) + "px";
        slides[moveIndexes[4] - 1].style.left = (this.getNextPosition(5)) + "px";
      }, 40);

    }
    setTimeout(() => {
      this.sliding = false;
    }, 1000);
  }

  getNextPosition(n) {
    return (this.attrs.sildeWidth * (n - 2)) + (10 * (n - 2));
  }

  getPrevPosition(n) {
    return (this.attrs.sildeWidth * (n - 1)) + (10 * (n - 1));
  }

  getMoveIndexes() {
    let moveIndexes = [];
    let x = 0;
    for (let i = 0; i < 5; i++) {
      let nextIndex = this.slideIndex + i;

      if (nextIndex > this.slideLength) {
        nextIndex = 1 + x;
        x++;
      }

      moveIndexes.push(nextIndex);
    }

    return moveIndexes;
  }

  setOriginalPosition() {
    let slides = document.getElementsByClassName(this.attrs.slideName);

    slides[0].style.left = (this.getPrevPosition(1)) + "px";

    for (let i = 1; i < slides.length; i++) {

      slides[i].style.left = (this.getPrevPosition(i + 1)) + "px";
    }

  }

  setAuto() {
    this.nextSlides();
    setTimeout(() => {
      if (this.auto)
        this.setAuto();
    }, 5000);
  }

  checkHover() {
    if (!this.canSlide) return;
    const isHover = e => e.parentElement.querySelector(':hover') === e;
    const myDiv = document.getElementById(this.attrs.containerId);

    if (isHover(myDiv)) {
      this.hover = true;
    } else {
      this.hover = false;
    }

  }
}
